import { render, staticRenderFns } from "./EmployerNavigation.vue?vue&type=template&id=3bae311a"
import script from "./EmployerNavigation.vue?vue&type=script&lang=ts"
export * from "./EmployerNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports